import { makeStyles } from "@material-ui/core/styles";
const minHeight = "32px";

const inputBoxStyles = makeStyles(() => ({
  input: {
    position: "relative",
    width: "100%",
    minHeight: minHeight,
    backgroundColor: "var(--color-white)",
    outline: "none",
    "&.MuiInputBase-root":{
      backgroundColor:'red'
    }

  },
  
  textfield: {
    minHeight: minHeight,
    fontSize: "var(--size-14px)",
    fontFamily: "var(--font-family-noto-sans)",
    lineHeight: "var(--size-16px)",
    borderRadius: "2px",
    border: "0.5px solid var(--color-medium-grey) ",
    "&.Mui-disabled": {
      backgroundColor: "var( --color-light-grey)",
      "&:hover": {
        backgroundColor: "var( --color-light-grey)"
      }
    },
    "&:hover": {
      backgroundColor: "var(--color-pale-grey)"
    },
    "&:focus-within": {
      backgroundColor: "var(--color-white)",
      boxShadow: "0px 0px 8px var(--color-shadow-primary)",
      border: "0.5px solid var(--color-light-teal)"
    },
    "&.Mui-error": {
      border: "0.5px solid var(--color-red)",
      boxShadow: "0px 0px 8px var(--color-shadow-red)"
    },
    
  },
  placeHolder: {
    fontSize: "var(--size-12px)",
    fontFamily: "var(--font-family-noto-sans)",
    lineHeight: "var(--size-14px)",
    paddingLeft: "40px"
  },
  label: {
    fontSize: 14,
    color: "var(--color-primary-black)"
  },
  labelDisabled: {
    color: "var(--color-primary-black)"
  },
  "&.MuiInputBase-root":{
    backgroundColor:'red'
  }
}));
export { inputBoxStyles };
